import { render, staticRenderFns } from "./moreNodeTree.vue?vue&type=template&id=b5070b8e&scoped=true"
import script from "./moreNodeTree.vue?vue&type=script&lang=js"
export * from "./moreNodeTree.vue?vue&type=script&lang=js"
import style0 from "./moreNodeTree.vue?vue&type=style&index=0&id=b5070b8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5070b8e",
  null
  
)

export default component.exports